import React, { useState, useContext } from 'react';
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { useToasts } from 'react-toast-notifications';
import axios from "axios";
import { Modal, Button, TextArea } from 'semantic-ui-react';
import { RadioGroup, Radio, TextField, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { selectFoiFocus } from "../slices/foiOfFocus/foiOfFocusSlice";
import { selectCurrentUserApiToken, selectCurrentUserName, selectCurrentUserId, selectCurrentUserNotificationEmail } from "../slices/currentUser/currentUserSlice";
import { selectToolName } from "../slices/footer/footerSlice";
import server_config from '../ServerConfiguration';

const fevir_node_server_address = server_config["fevir_node_server_address"];

const EmptyBoxCharacter = () => {
  return <span className="box emptyBox">☐&nbsp;</span>;
}

const submitFeedback = async (toolName, foi, hash, userName, apiToken, userNotificationEmail, feedBackState, setFeedBackState, feedbackTypeState, setFeedbackTypeState, setFeedBackModalOpenState, addToast) => {
  let feedbackjson = {
    "resourceType": "ArtifactAssessment",
    "artifactReference": {
      "display": toolName
    },
    "content": []
  };
  if (feedBackState.learningCurve) {
    feedbackjson["content"].push({
      "type": {
        "text": "Easy/Hard to learn 5-item Likert rating"
      },
      "classifier": [
        {
          "text": feedBackState.learningCurve
        }
      ]
    });
  }
  if (feedBackState.easeOfUse) {
    feedbackjson["content"].push({
      "type": {
        "text": "Easy/Hard to use 5-item Likert rating"
      },
      "classifier": [
        {
          "text": feedBackState.easeOfUse
        }
      ]
    });
  }
  if (feedBackState.experienceUsingTool) {
    feedbackjson["content"].push({
      "type": {
        "text": "Good/Poor experience 5-item Likert rating"
      },
      "classifier": [
        {
          "text": feedBackState.experienceUsingTool
        }
      ]
    });
  }

  if (feedbackTypeState) {
    feedbackjson["content"].push({
      "type": {
        "text": "Feedback Type"
      },
      "classifier": [
        {
          "text": feedbackTypeState
        }
      ]
    });
  }

  if (feedBackState.additionalComment) {
    let feedbackComment = {
      "type": {
        "text": "Do you have any additional comments?"
      },
      "summary": feedBackState.additionalComment,
      "author": [{ "display": "Anonymous" }]
    };
    if (userName) {
      feedbackComment["author"][0]["display"] = userName;
    }
    feedbackjson["content"].push(feedbackComment);
  }

  let feedbackData = {
    'functionid': foi === "27270" || foi === "293778" ? "sevcofeedbacksubmit" : "simpleusabilityfeedbacksubmit",
    'tool': foi === "27270" || foi === "293778" ? "sevcofeedbackform" : "simpleusabilityfeedbackform",
    'feedbackOnTool': toolName,
    'userEmail': userNotificationEmail,
    'foi': foi,
    'hash': hash,
    'fhirEntry': JSON.stringify(feedbackjson, null, 2),
    'title': "",
    'status': "active",
    'apiToken': apiToken
  };
  if (foi && hash) {
    feedbackData["path"] = foi + "#" + hash;
  }
  await axios({
    method: 'POST',
    url: fevir_node_server_address,
    timeout: 10000,
    data: feedbackData,
  }).then((resp) => {
    if (resp?.data?.success === false) {
      //changeMedlineEntryState(false, "loadingSubmission");
      alert("We were unable to submit your feedback.");
    } else {
      //alert("success");
      setFeedBackState({});
      setFeedbackTypeState("");
      setFeedBackModalOpenState(false);
      addToast('Feedback submitted. Thank you.', { appearance: 'success' });
      //close out of modal?
    }
  }).catch((error) => { console.log(error); });
}

const FeedbackModal = ({ feedBackModalOpenState, setFeedBackModalOpenState, feedBackState, setFeedBackState, pageTitle, foi, hash, toolName, addToast }) => {
  const userName = useSelector(selectCurrentUserName);
  const apiToken = useSelector(selectCurrentUserApiToken);
  const userNotificationEmail = useSelector(selectCurrentUserNotificationEmail);

  return (
    <Modal
      style={{ width: "60%", padding: "16px", margin: "16px", border: "2px solid #00000044" }}
      dimmer={<Modal.Dimmer style={{ backgroundColor: "#00000077" }} />}
      open={feedBackModalOpenState}
      centered={false}
      content={<div style={{ whiteSpace: "pre-wrap" }}>
        <Button style={{ padding: "6px", position: "absolute", right: "14px" }} className="formButton negative" content="✖"
          onClick={() => {
            setFeedBackModalOpenState(false);
          }}
        />
        <div style={{ fontSize: "16px" }}>
          <h2 style={{ paddingTop: "0px", marginTop: "0px" }}>The <u>{toolName}</u> is:</h2>
          <br />
          <div>
            {/*<span><b>Please rate your experience:</b>&nbsp;&nbsp;&nbsp;&nbsp;
              <Dropdown
                  name="yourExperience"
                  placeholder="Your experience"
                  className={"thinDropdown"}
                  closeOnChange selection clearable selectOnBlur={false} autoComplete="off"
                  style={{ width: "240px", paddingTop: "6px", paddingBottom: "6px" }}
                  options={[ { key: "Good", text: "Good", value: "Good" }, { key: "Bad", text: "Bad", value: "Bad" } ]}
                  value={feedBackState.yourExperience || ''}
                  onChange={(e, data) => { setFeedBackState(prevState  => { return { ...prevState, "yourExperience": data.value } });  } }
                />
            </span>
            <br/>*/}
            <span>
              <table className="noStyleTable"><tbody>
                <tr>
                  <td style={{ textAlign: "right", fontWeight: "bold" }}>Easy to Learn</td>
                  <td>
                    <RadioGroup
                      aria-label="LearningCurve"
                      name="LearningCurve"
                      label="LearningCurve"
                      value={feedBackState.learningCurve}
                      onChange={(e) => { setFeedBackState(prevState => { return { ...prevState, "learningCurve": e.target.value } }); }}
                      row={true}
                    >
                      <Radio value="1 Very Easy to Learn" />
                      <Radio value="2 Somewhat Easy to Learn" />
                      <Radio value="3 Neither Easy nor Hard to Learn" />
                      <Radio value="4 Somewhat Hard to Learn" />
                      <Radio value="5 Very Hard to Learn" />
                    </RadioGroup>
                  </td>
                  <td style={{ textAlign: "left", fontWeight: "bold" }}>Hard to Learn</td>
                </tr>
                <tr>
                  <td style={{ textAlign: "right", fontWeight: "bold" }}>Easy to Use</td>
                  <td>
                    <RadioGroup
                      aria-label="EaseOfUse"
                      name="EaseOfUse"
                      label="EaseOfUse"
                      value={feedBackState.easeOfUse}
                      onChange={(e) => { setFeedBackState(prevState => { return { ...prevState, "easeOfUse": e.target.value } }); }}
                      row={true}
                    >
                      <Radio value="1 Very Easy to Use" />
                      <Radio value="2 Somewhat Easy to Use" />
                      <Radio value="3 Neither Easy nor Hard to Use" />
                      <Radio value="4 Somewhat Hard to Use" />
                      <Radio value="5 Very Hard to Use" />
                    </RadioGroup>
                  </td>
                  <td style={{ textAlign: "left", fontWeight: "bold" }}>Hard to Use</td>
                </tr>
                <tr>
                  <td style={{ textAlign: "right", fontWeight: "bold" }}>A good experience</td>
                  <td>

                    <RadioGroup
                      aria-label="ExperienceUsingTool"
                      name="ExperienceUsingTool"
                      label="ExperienceUsingTool"
                      value={feedBackState.goodBadLook}
                      onChange={(e) => { setFeedBackState(prevState => { return { ...prevState, "experienceUsingTool": e.target.value } }); }}
                      row={true}
                    >
                      <Radio value="1 Very Good Experience" />
                      <Radio value="2 Somewhat Good Experience" />
                      <Radio value="3 Neither Good nor Poor Experience" />
                      <Radio value="4 Somewhat Poor Experience" />
                      <Radio value="5 Very Poor Experience" />
                    </RadioGroup>
                  </td>
                  <td style={{ textAlign: "left", fontWeight: "bold" }}>A poor experience</td>
                </tr>
              </tbody></table>
            </span>
            <br />
            <p><b>Do you have any additional comments?</b>
              <TextArea style={{ marginTop: "4px", padding: "2px", width: "98%" }} rows={5} className="inputField" type='text' label={'Additional Comment'} size="small" variant='outlined' value={feedBackState.additionalComment} onChange={(e) => { setFeedBackState(prevState => { return { ...prevState, "additionalComment": e.target.value } }); }} />
            </p>
            <br />
            <br />
          </div>
          <Button style={{ color: "#000000" }} className="formButton" content="Submit Feedback"
            onClick={() => { submitFeedback(toolName, foi, hash, userName, apiToken, userNotificationEmail, feedBackState, setFeedBackState, null, null, setFeedBackModalOpenState, addToast); }} />
        </div>
      </div>}
    />
  )
}

const SEVCOFeedbackModal = ({ feedBackModalOpenState, setFeedBackModalOpenState, feedBackState, setFeedBackState, pageTitle, foi, hash, toolName, addToast }) => {
  const userName = useSelector(selectCurrentUserName);
  const apiToken = useSelector(selectCurrentUserApiToken);
  const userNotificationEmail = useSelector(selectCurrentUserNotificationEmail);
  const [userEmailState, setUserEmailState] = useState(userNotificationEmail);
  const [userNameState, setUserNameState] = useState(userName);
  const [feedbackTypeState, setFeedbackTypeState] = useState("");

  return (
    <Modal
      style={{ width: "60%", padding: "16px", margin: "16px", border: "2px solid #00000044" }}
      dimmer={<Modal.Dimmer style={{ backgroundColor: "#00000077" }} />}
      open={feedBackModalOpenState}
      centered={false}
      content={<div style={{ whiteSpace: "pre-wrap" }}>
        <Button style={{ padding: "6px", position: "absolute", right: "14px" }} className="formButton negative" content="✖"
          onClick={() => {
            setFeedBackModalOpenState(false);
          }}
        />
        <div style={{ fontSize: "16px" }}>
          <h2 style={{ paddingTop: "0px", marginTop: "0px" }}>SEVCO CodeSystem Feedback:</h2>
          <br />
          <div>
            {/*<span><b>Please rate your experience:</b>&nbsp;&nbsp;&nbsp;&nbsp;
              <Dropdown
                  name="yourExperience"
                  placeholder="Your experience"
                  className={"thinDropdown"}
                  closeOnChange selection clearable selectOnBlur={false} autoComplete="off"
                  style={{ width: "240px", paddingTop: "6px", paddingBottom: "6px" }}
                  options={[ { key: "Good", text: "Good", value: "Good" }, { key: "Bad", text: "Bad", value: "Bad" } ]}
                  value={feedBackState.yourExperience || ''}
                  onChange={(e, data) => { setFeedBackState(prevState  => { return { ...prevState, "yourExperience": data.value } });  } }
                />
            </span>
            <br/>*/}
            <b>Feedback Type: </b>
            <ToggleButtonGroup
              className="genericToggleButtonGroup buttonGroupWrap extrathin"
              exclusive
              value={feedbackTypeState}
              aria-label="Feedback Type"
              name="Feedback Type"
            >
              <ToggleButton className="genericToggleButton" color="primary"
                aria-label="Request to change a specific term" value="Request to change a specific term"
                onClick={() => { setFeedbackTypeState("Request to change a specific term"); }}>
                <span>
                  {feedbackTypeState === "Request to change a specific term" ? <span className="box">☑&nbsp;</span> : <EmptyBoxCharacter />}
                </span>
                Request to change a specific term
              </ToggleButton>
              <ToggleButton className="genericToggleButton" color="primary"
                aria-label="Question about a specific term" value="Question about a specific term"
                onClick={() => { setFeedbackTypeState("Question about a specific term"); }}>
                <span>
                  {feedbackTypeState === "Question about a specific term" ? <span className="box">☑&nbsp;</span> : <EmptyBoxCharacter />}
                </span>
                Question about a specific term
              </ToggleButton>
              <ToggleButton className="genericToggleButton" color="primary"
                aria-label="Request to add a term" value="Request to add a term"
                onClick={() => { setFeedbackTypeState("Request to add a term"); }}>
                <span>
                  {feedbackTypeState === "Request to add a term" ? <span className="box">☑&nbsp;</span> : <EmptyBoxCharacter />}
                </span>
                Request to add a term
              </ToggleButton>
              <ToggleButton className="genericToggleButton" color="primary"
                aria-label="General question about SEVCO" value="General question about SEVCO"
                onClick={() => { setFeedbackTypeState("General question about SEVCO"); }}>
                <span>
                  {feedbackTypeState === "General question about SEVCO" ? <span className="box">☑&nbsp;</span> : <EmptyBoxCharacter />}
                </span>
                General question about SEVCO
              </ToggleButton>
              <ToggleButton className="genericToggleButton" color="primary"
                aria-label="Other" value="Other"
                onClick={() => { setFeedbackTypeState("Other"); }}>
                <span>
                  {feedbackTypeState === "Other" ? <span className="box">☑&nbsp;</span> : <EmptyBoxCharacter />}
                </span>
                Other
              </ToggleButton>
            </ToggleButtonGroup>
            <br />
            <br />
            <p><b>Feedback:</b>
              <TextArea style={{ marginTop: "4px", padding: "2px", width: "98%" }} rows={5} className="inputField" type='text' label={'Additional Comment'} size="small" variant='outlined' value={feedBackState.additionalComment} onChange={(e) => { setFeedBackState(prevState => { return { ...prevState, "additionalComment": e.target.value } }); }} />
            </p>
            <br />
            <TextField style={{ width: "460px" }} className="inputField" type='text'
              label='Your Name' size="small" variant='outlined'
              value={userNameState || ''}
              onChange={(e) => { setUserNameState(e.target.value); }}
            />
            <br />
            <br />
            <TextField style={{ width: "460px" }} className="inputField" type='text'
              label='Your Email' size="small" variant='outlined'
              value={userEmailState || ''}
              onChange={(e) => { setUserEmailState(e.target.value); }}
            />
            <br />
            <br />
          </div>
          <Button style={{ color: "#000000" }} className="formButton" content="Submit Feedback"
            onClick={() => { submitFeedback(toolName, foi, hash, userNameState, apiToken, userEmailState, feedBackState, setFeedBackState, feedbackTypeState, setFeedbackTypeState, setFeedBackModalOpenState, addToast); }} />
        </div>
      </div>}
    />
  )
}

const FeedbackButton = ({ pageTitle }) => {
  const location = useLocation();
  const toolName = useSelector(selectToolName);
  const foi = useSelector(selectFoiFocus);
  const userId = useSelector(selectCurrentUserId);
  const isLoggedIn = (!!userId && userId !== "1");
  let hashCode = location.hash?.substring(1);
  const [feedBackModalOpenState, setFeedBackModalOpenState] = useState(false);
  const [feedBackState, setFeedBackState] = useState({});
  const { addToast } = useToasts();

  return <div>
    {(foi === "27270"  || foi === "293778") ?
      <SEVCOFeedbackModal feedBackModalOpenState={feedBackModalOpenState}
        setFeedBackModalOpenState={setFeedBackModalOpenState} feedBackState={feedBackState} setFeedBackState={setFeedBackState}
        pageTitle={pageTitle} toolName={toolName} foi={foi} hash={hashCode} addToast={addToast} />
      :
      <FeedbackModal feedBackModalOpenState={feedBackModalOpenState}
        setFeedBackModalOpenState={setFeedBackModalOpenState} feedBackState={feedBackState} setFeedBackState={setFeedBackState}
        pageTitle={pageTitle} toolName={toolName} foi={foi} hash={hashCode} addToast={addToast} />
    }
    <div className="feedbackButton" style={{ opacity: "0.6", zIndex: "10", position: "absolute", cursor: "pointer", marginTop: "3px", right: "36px" }}><div
      className={"unselectable"}
      style={{ backgroundColor: "lavender", fontSize: "24px", padding: "4px 8px", border: "2px solid #000000", borderRadius: "5px" }}
      onClick={() => {
        if ((foi === "27270" || foi === "293778") && !isLoggedIn) {
          alert("Please login to provide feedback about SEVCO.");
        } else {
          setFeedBackModalOpenState(true);
        }
      }}
    ><span style={{ fontSize: "16px", fontWeight: "bold" }}>Feedback</span> 💬</div>
    </div>
  </div>;
};

export default FeedbackButton;